export let onlyView = {
    cart:'cart',// 购物车页面
    billsCP:'billsCP',// 订单页面
    generateOrderDetail:'generateOrderDetail',// 订单详情页面
    productDetail:'productDetail',// 产品详情页面
    packOrder:'packOrder',// 打包单页面
    addEditPackOrder:'addEditPackOrder',// 打包单详情页面
}


// WEBPACK FOOTER //
// ./src/utils/onlyView.js